export default __webpack_public_path__ + "img/return.36d012ec.svg";